export const googleStreet = () => ({
    version: 8,
    name: "Google Streets",
    sources: {
        composite: {
            type: "raster",
            tileSize: 256,
            tiles: ["https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", "https://mt2.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"],
            attribution: '© <a target="_top" rel="noopener" href="https://google.com">Google</a>',
        },
    },
    center: [52.9088, 32.8927],
    zoom: 5,
    glyphs: "/fonts/{fontstack}/{range}.pbf",
    layers: [
        { id: "land", type: "background", metadata: {}, layout: {}, paint: { "background-color": ["interpolate", ["linear"], ["zoom"], 11, "hsl(35, 32%, 91%)", 13, "hsl(35, 12%, 89%)"] } },
        {
            id: "simple-tiles",
            type: "raster",
            source: "composite",
            minzoom: 0,
            maxzoom: 22,
        },
    ],
    visibility: "public",
    owner: "Arian Artan",
    draft: false,
});

export const googleSatellite = () => ({
    version: 8,
    name: "Google Satellite",
    sources: {
        composite: {
            type: "raster",
            tileSize: 256,
            tiles: ["https://mt0.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", "https://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", "https://mt2.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"],
            attribution: '© <a target="_top" rel="noopener" href="https://google.com">Google</a>',
        },
    },
    center: [52.9088, 32.8927],
    zoom: 5,
    maxzoom: 18,
    glyphs: "/fonts/{fontstack}/{range}.pbf",
    layers: [
        { id: "land", type: "background", metadata: {}, layout: {}, paint: { "background-color": ["interpolate", ["linear"], ["zoom"], 11, "hsl(35, 32%, 91%)", 13, "hsl(35, 12%, 89%)"] } },
        {
            id: "simple-tiles",
            type: "raster",
            source: "composite",
            minzoom: 0,
            maxzoom: 18,
        },
    ],
    visibility: "public",
    owner: "Arian Artan",
    draft: false,
});
